import * as React from 'react';
import GetStarted from './get-started/get-started';

const Home = () => (
    <GetStarted />
);

export default Home;
